import SincronizacaoPropostasDto from '@/models/dto/SincronizacaoPropostasDto';
import AcordoExternoResource from './AcordoExternoResource';
import PropostaNovoResource from './PropostaNovoResource';

export default class SincronizacaoPropostasResource {
  acordosExternos: AcordoExternoResource[];
  propostas: PropostaNovoResource[];

  constructor(api: string, dto: SincronizacaoPropostasDto) {
    this.acordosExternos = dto.acordosExternos.map((a) => new AcordoExternoResource(api, a));
    this.propostas = dto.propostas.map((p) => new PropostaNovoResource(p));
  }
}
